/**
 * Discount Manager - Gerencia códigos de desconto
 * Utilitário reutilizável para aplicar códigos de desconto no Shopify
 */

class DiscountManager {
  constructor() {
    this.baseUrl = window.location.origin;
  }

  async applyDiscountCode(discountCode) {
    try {
      const discountUrl = `${this.baseUrl}/discount/${discountCode}`;      
      const response = await fetch(discountUrl, {
        method: 'GET',
        headers: {
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
        }
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP ao aplicar desconto: ${response.status}`);
      }

      return true;
    } catch (error) {
      console.error('Erro ao aplicar código de desconto:', error);
      throw error;
    }
  }

  async verifyDiscountApplied(discountCode) {
    try {
      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!cartResponse.ok) {
        throw new Error(`Erro ao buscar carrinho: ${cartResponse.status}`);
      }

      const cartData = await cartResponse.json();

      const isDiscountActive = cartData.discount_codes.some(
        discount => discount.code === discountCode && discount.applicable
      );

      return isDiscountActive;
    } catch (error) {
      console.error('Erro ao verificar desconto aplicado:', error);
      return false;
    }
  }

  async applyAndVerifyDiscount(discountCode) {
    try {
      await this.applyDiscountCode(discountCode);
      
      const isApplied = await this.verifyDiscountApplied(discountCode);
      
      if (!isApplied) {
        throw new Error('Código de desconto inválido ou inexistente');
      }

      return true;
    } catch (error) {
      console.error(`Falha ao aplicar desconto "${discountCode}":`, error);
      throw error;
    }
  }

  async applyMultipleDiscounts(discountCodes) {
    const results = {
      success: [],
      failed: []
    };

    for (const discountCode of discountCodes) {
      try {
        await this.applyAndVerifyDiscount(discountCode.code);
        results.success.push(discountCode.code);
      } catch (error) {
        console.error(`Falha ao aplicar desconto "${discountCode.code}":`, error);
        results.failed.push(discountCode.code);
      }
    }

    return results;
  }

  async getActiveDiscountCodes() {
    try {
      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!cartResponse.ok) {
        throw new Error(`Erro ao buscar carrinho: ${cartResponse.status}`);
      }

      const cartData = await cartResponse.json();
      return cartData.discount_codes
        .filter(discount => discount.applicable)
        .map(discount => discount.code);
    } catch (error) {
      console.error('Erro ao obter códigos de desconto ativos:', error);
      return [];
    }
  }
}

window.DiscountManager = DiscountManager;
